/* FeelBem 2.0 — interactions. No dependencies. */
(() => {
  const fmtMoney = (c) => 'R$ ' + (c / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  const d = document, root = d.documentElement, $ = (s, c = d) => c.querySelector(s), $$ = (s, c = d) => [...c.querySelectorAll(s)];
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* header: transparent over the home hero, glass pills after scrolling */
  const onScroll = () => root.classList.toggle('is-scrolled', scrollY > 24);
  onScroll(); addEventListener('scroll', onScroll, { passive: true });

  /* mega menu (desktop) */
  const megaBtn = $('[data-mega-btn]'), mega = $('[data-mega]');
  if (megaBtn && mega) {
    let t;
    const open = () => { clearTimeout(t); mega.classList.add('is-open'); megaBtn.setAttribute('aria-expanded', 'true'); };
    const close = () => { t = setTimeout(() => { mega.classList.remove('is-open'); megaBtn.setAttribute('aria-expanded', 'false'); }, 160); };
    megaBtn.addEventListener('click', () => mega.classList.contains('is-open') ? (clearTimeout(t), mega.classList.remove('is-open'), megaBtn.setAttribute('aria-expanded', 'false')) : open());
    [megaBtn, mega].forEach(el => { el.addEventListener('mouseenter', open); el.addEventListener('mouseleave', close); });
    d.addEventListener('keydown', e => { if (e.key === 'Escape') { mega.classList.remove('is-open'); megaBtn.setAttribute('aria-expanded', 'false'); } });
  }

  /* mobile sheet */
  const sheet = $('[data-sheet]'), sheetBtn = $('[data-sheet-open]');
  const closeSheet = () => { if (!sheet || sheet.hidden) return; sheet.hidden = true; sheetBtn && sheetBtn.setAttribute('aria-expanded', 'false'); d.body.style.overflow = ''; };
  sheetBtn && sheetBtn.addEventListener('click', () => { sheet.hidden = false; sheetBtn.setAttribute('aria-expanded', 'true'); d.body.style.overflow = 'hidden'; $('[data-sheet-close]', sheet).focus(); });
  sheet && sheet.addEventListener('click', e => { if (e.target === sheet || e.target.closest('[data-sheet-close]')) closeSheet(); });

  /* line dock (home tabs) */
  const dock = $('[data-dock]');
  const placeThumb = () => {
    if (!dock) return;
    const btn = $(`[data-line-btn="${root.dataset.line}"]`, dock) || $('[data-line-btn]', dock), th = $('.dock__thumb', dock);
    $$('[data-line-btn]', dock).forEach(b => b.setAttribute('aria-selected', b === btn ? 'true' : 'false'));
    th.style.width = btn.offsetWidth + 'px'; th.style.transform = `translateX(${btn.offsetLeft - 5}px)`;
  };
  const syncQuiz = () => { $$('[data-quiz-link][data-follow-line]').forEach(a => { a.href = '/pages/quiz-' + root.dataset.line; }); };
  syncQuiz();
  const setLine = (line) => {
    if (root.dataset.line === line) { scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); return; }
    const swap = () => {
      root.dataset.line = line;
      try { sessionStorage.setItem('fbLine', line); } catch (e) {}
      const u = new URL(location.href); u.searchParams.set('linha', line); history.replaceState(null, '', u);
      placeThumb(); refresh(); syncQuiz(); d.dispatchEvent(new CustomEvent('fb:line', { detail: line }));
    };
    if (reduce) { swap(); return; }
    root.classList.add('is-switching');
    setTimeout(() => { if (scrollY > innerHeight * .4) scrollTo({ top: 0, behavior: 'auto' }); swap(); requestAnimationFrame(() => root.classList.remove('is-switching')); }, 300);
  };
  if (dock) {
    placeThumb(); addEventListener('resize', placeThumb); d.fonts && d.fonts.ready.then(placeThumb);
    dock.addEventListener('click', e => { const b = e.target.closest('[data-line-btn]'); if (b) setLine(b.dataset.lineBtn); });
    dock.addEventListener('keydown', e => {
      if (!['ArrowLeft', 'ArrowRight'].includes(e.key)) return;
      const bs = $$('[data-line-btn]', dock), i = bs.findIndex(b => b.dataset.lineBtn === root.dataset.line);
      const n = bs[(i + (e.key === 'ArrowRight' ? 1 : bs.length - 1)) % bs.length]; n.focus(); setLine(n.dataset.lineBtn);
    });
    const ft = $('.ft');
    ft && new IntersectionObserver(([en]) => dock.classList.toggle('is-hidden', en.isIntersecting), { rootMargin: '0px 0px -30% 0px' }).observe(ft);
  }

  /* evergreen countdown to midnight, Brasília */
  const tick = () => {
    const br = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Sao_Paulo' }));
    const end = new Date(br); end.setHours(24, 0, 0, 0);
    let s = Math.max(0, Math.floor((end - br) / 1000));
    const h = String(Math.floor(s / 3600)).padStart(2, '0'); s %= 3600;
    const m = String(Math.floor(s / 60)).padStart(2, '0'), ss = String(s % 60).padStart(2, '0');
    $$('[data-countdown]').forEach(c => { $('[data-h]', c).textContent = h; $('[data-m]', c).textContent = m; $('[data-s]', c).textContent = ss; });
  };
  if ($('[data-countdown]')) { tick(); setInterval(tick, 1000); }

  /* cart */
  const drawer = $('[data-drawer]'); let lastFocus = null;
  const openCart = () => { if (!drawer) return; lastFocus = d.activeElement; drawer.hidden = false; d.body.style.overflow = 'hidden'; setTimeout(() => $('.drawer__head [data-cart-close]', drawer)?.focus(), 40); };
  const closeCart = () => { if (!drawer || drawer.hidden) return; drawer.hidden = true; d.body.style.overflow = ''; lastFocus && lastFocus.focus(); };
  $$('[data-cart-open]').forEach(b => b.addEventListener('click', openCart));
  drawer && drawer.addEventListener('click', e => { if (e.target.closest('[data-cart-close]')) closeCart(); });
  d.addEventListener('keydown', e => { if (e.key === 'Escape') { closeCart(); closeSheet(); } });
  $$('[data-cart-count]').forEach(c => c.toggleAttribute('data-zero', c.textContent.trim() === '0'));

  const renderCart = async () => {
    const r = await fetch(`${FB.root}?section_id=fb-cart-items`.replace('//?', '/?'));
    const tmp = d.createElement('div'); tmp.innerHTML = await r.text();
    const node = $('[data-cart-render]', tmp); if (!node) return;
    $$('[data-cart-body]').forEach(b => b.innerHTML = node.outerHTML);
    const count = node.dataset.count;
    $$('[data-cart-count]').forEach(c => { c.textContent = count; c.toggleAttribute('data-zero', count === '0'); });
    $$('[data-cart-total]').forEach(t => t.innerHTML = node.dataset.total);
    const foot = $('[data-cart-foot]'); if (foot) foot.hidden = count === '0';
  };
  window.FB = window.FB || {}; FB.renderCart = renderCart; FB.openCart = openCart;
  const addToCart = async (id, btn) => {
    btn && (btn.disabled = true);
    try {
      const r = await fetch(FB.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }) });
      if (!r.ok) { const j = await r.json().catch(() => ({})); btn && (btn.textContent = j.description || 'Indisponível'); return; }
      await renderCart(); openCart();
    } finally { btn && (btn.disabled = false); }
  };
  d.addEventListener('submit', e => {
    const f = e.target;
    if (f.matches('[data-quick-add]') || f.matches('[data-buy]')) { e.preventDefault(); addToCart(f.querySelector('[name="id"]').value, f.querySelector('[type="submit"]')); }
  });
  d.addEventListener('click', async e => {
    const q = e.target.closest('[data-qty]'); if (!q) return;
    const li = q.closest('[data-key]'); if (!li) return; li.classList.add('is-busy');
    await fetch(FB.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: li.dataset.key, quantity: Number(q.dataset.qty) }) });
    await renderCart();
  });

  /* PDP */
  const pdp = $('[data-pdp]');
  if (pdp) {
    const track = $('[data-slides]', pdp), thumbs = $$('[data-thumb]', pdp), dots = $$('.gal__dots i', pdp);
    thumbs.forEach(t => t.addEventListener('click', () => track.scrollTo({ left: track.clientWidth * +t.dataset.thumb, behavior: reduce ? 'auto' : 'smooth' })));
    track && track.addEventListener('scroll', () => { const i = Math.round(track.scrollLeft / track.clientWidth); thumbs.forEach((t, k) => t.classList.toggle('is-on', k === i)); dots.forEach((t, k) => t.classList.toggle('is-on', k === i)); }, { passive: true });
    const idIn = $('[data-variant-id]', pdp), add = $('[data-add]', pdp), plan = $('[data-fbar-plan]');
    $$('input[name="fb-plan"]', pdp).forEach(r => r.addEventListener('change', () => {
      idIn.value = r.value; $$('[data-add-price]').forEach(p => p.textContent = r.dataset.price);
      const cb = Math.floor(Number(r.dataset.cents || 0) * 25 / 100); $$('[data-cb-amt]', pdp).forEach(n => n.textContent = fmtMoney(cb));
      if (plan) plan.firstChild.textContent = r.dataset.title + ' · ';
      const ok = r.dataset.avail === 'true'; add.disabled = !ok; $('[data-add-label]', add).textContent = ok ? 'Adicionar à sacola' : 'Esgotado';
      history.replaceState(null, '', r.dataset.url);
    }));
    const bar = $('[data-fbar]');
    if (bar && add) {
      new IntersectionObserver(([en]) => { const on = !en.isIntersecting && en.boundingClientRect.top < 0; bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true'); $('[data-fbar-add]', bar).tabIndex = on ? 0 : -1; }).observe(add);
      $('[data-fbar-add]', bar).addEventListener('click', e => addToCart(idIn.value, e.currentTarget));
    }
  }

  /* collection filter */
  const grid = $('[data-grid]');
  grid && $$('[data-filter]').forEach(b => b.addEventListener('click', () => {
    $$('[data-filter]').forEach(x => x.classList.toggle('is-on', x === b));
    const f = b.dataset.filter;
    $$('.cell', grid).forEach(c => c.hidden = !(f === 'all' || c.dataset.fmt === f));
    $$('[data-promo]', grid).forEach(p => p.hidden = f !== 'all');
  }));

  /* goals tabs */
  $$('[data-goals]').forEach(g => g.addEventListener('click', e => {
    const b = e.target.closest('[data-goal-tab]'); if (!b) return; const i = b.dataset.goalTab;
    $$('[data-goal-tab]', g).forEach(x => x.setAttribute('aria-selected', x === b ? 'true' : 'false'));
    $$('[data-goal-panel]', g).forEach(p => p.hidden = p.dataset.goalPanel !== i);
    $$('[data-goal-img]', g).forEach(im => im.classList.toggle('is-on', im.dataset.goalImg === i));
  }));
  /* quality tabs (auto-advance until touched) */
  $$('[data-qual]').forEach(q => {
    const tabs = $$('[data-qual-tab]', q), items = $$('[data-qual-item]', q); let i = 0, auto = true;
    const show = (k) => { i = k; tabs.forEach((t, j) => t.setAttribute('aria-selected', j === k ? 'true' : 'false')); items.forEach((it, j) => it.classList.toggle('is-on', j === k)); };
    tabs.forEach((t, k) => t.addEventListener('click', () => { auto = false; show(k); }));
    if (!reduce && tabs.length > 1) setInterval(() => { if (auto && q.getBoundingClientRect().top < innerHeight && q.getBoundingClientRect().bottom > 0) show((i + 1) % tabs.length); }, 3800);
  });
  /* rails */
  $$('[data-rail]').forEach(r => {
    const sec = r.closest('section'), step = () => Math.max(260, r.clientWidth * .7);
    $('[data-rail-next]', sec)?.addEventListener('click', () => r.scrollBy({ left: step(), behavior: 'smooth' }));
    $('[data-rail-prev]', sec)?.addEventListener('click', () => r.scrollBy({ left: -step(), behavior: 'smooth' }));
  });

  /* reveal + count-up */
  function initReveal() {
    if (reduce || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver(ens => ens.forEach(en => { if (en.isIntersecting) { en.target.classList.remove('rv-wait'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -6% 0px' });
    $$('[data-rv]').forEach(el => { const r = el.getBoundingClientRect(); if (r.top > innerHeight && r.width && !el.dataset.rvd) { el.dataset.rvd = 1; el.classList.add('rv-wait'); io.observe(el); } });
  }
  function initCounts() {
    if (reduce || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver(ens => ens.forEach(en => {
      if (!en.isIntersecting) return; io.unobserve(en.target);
      const el = en.target, raw = el.dataset.count, target = parseFloat(raw.replace(/\./g, '').replace(',', '.')); if (isNaN(target)) return;
      const dec = (raw.split(',')[1] || '').length, t0 = performance.now(), dur = 1400, fmt = (v) => v.toLocaleString('pt-BR', { minimumFractionDigits: dec, maximumFractionDigits: dec, useGrouping: raw.includes('.') });
      const step = (t) => { const k = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - k, 3); el.textContent = fmt(target * e); if (k < 1) requestAnimationFrame(step); else el.textContent = raw; };
      requestAnimationFrame(step);
    }), { threshold: .6 });
    $$('[data-count]').forEach(el => { if (!el.dataset.cd && el.offsetParent) { el.dataset.cd = 1; io.observe(el); } });
  }

  /* scroll-linked */
  const stepsTick = () => $$('[data-steps]').forEach(s => {
    if (!s.offsetParent) return;
    const r = s.getBoundingClientRect(), mid = innerHeight * .58, p = Math.min(1, Math.max(0, (mid - r.top) / r.height));
    $('[data-steps-fill]', s)?.style.setProperty('--p', p.toFixed(3));
    $$('[data-step]', s).forEach(st => st.classList.toggle('is-on', st.getBoundingClientRect().top < mid));
  });
  const reveal = $('[data-reveal]'), mega2 = $('[data-mega]', reveal || d.createElement('i'));
  let ticking = false;
  const frame = () => {
    ticking = false; stepsTick();
    if (reduce) return;
    $$('[data-parallax]').forEach(el => { const r = el.getBoundingClientRect(); if (!r.height || r.bottom < 0 || r.top > innerHeight) return; const k = (r.top + r.height / 2 - innerHeight / 2) / innerHeight; el.style.transform = `translate3d(0,${(k * -5).toFixed(2)}%,0)`; });
    if (reveal) {
      const r = reveal.getBoundingClientRect(), k = Math.min(1, Math.max(0, (innerHeight - r.top) / (r.height * .9)));
      reveal.style.setProperty('--s', (1.12 - k * .12).toFixed(3));
      mega2 && $$('span', mega2).forEach((s, i) => { const kk = Math.min(1, Math.max(0, k * 1.6 - i * .18)); s.style.setProperty('--y', ((1 - kk) * 60).toFixed(1) + '%'); s.style.setProperty('--o', kk.toFixed(2)); });
    }
  };
  addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }, { passive: true });
  addEventListener('resize', frame);
  function refresh() { initReveal(); initCounts(); frame(); }
  refresh();
})();
